<template>
  <CContainer class="pt-5 mb-5" fluid>
    <Loading :active.sync="isLoading"></Loading>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">Notaris</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/notaris">
            <CIcon name="cil-balance-scale" />
            Notaris
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Edit</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <!-- <CRow>
      <CCol class="col-12 ml-3 mb-1">
        <b-input-group class="custom-input-group-white">
          <b-input-group-prepend is-text>
            Selected Office
          </b-input-group-prepend>
          <b-input-group-prepend>
            <multiselect 
              v-model="formData.office.value" 
              :options="formData.office.options" 
              :state="formData.office.isValid"
              :class="{custom_multiselect_invalid: formData.office.isValid === false}"
              id="form-office"
              placeholder="Select an option"
              :showLabels="false"
              :loading="!formData.office.isLoaded"
              openDirection="bottom"
              label="nameFull"
              track-by="officeCode"
              :internalSearch="false"
              :preserveSearch="true"
              @search-change="populateSelectOffice"
            >
              <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
              <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
              <template slot="noResult">No elements found.</template>
              <template slot="afterList" v-if="formData.office.currentPage < formData.office.totalPages">
                <div class="text-center custom-cursor-clickable p-2" @click="appendSelectOffice" v-if="formData.office.isLoaded">
                  <span class="text-muted">Load More</span>
                </div>
                <div class="text-center" v-else>
                  <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                </div>
              </template>
            </multiselect>
          </b-input-group-prepend>
        </b-input-group>
      </CCol>
    </CRow> -->
    <CForm>
      <CRow class="mb-5">
        <CCol class="col-12">
          <CCard class="custom-form-card custom-card ml-2 mr-2">
            <CCardBody>
              <CRow>
                <CCol class="col-md-12 col-lg-6 pb-3">
                  <CRow>
                    <!-- <CCol class="col-12">
                      <h5 class="custom-header">Data Vendor</h5>
                      <CRow>
                        <CCol class="col-12">
                          <b-form-group
                            :invalid-feedback="formData.vendorId.feedback"
                            valid-feedback="Vendor ID is available."
                            label="Vendor ID"
                            label-for="form-vendor-id"
                            :state="formData.vendorId.isValid"
                          >
                            <b-input-group>
                              <b-form-input
                                v-model="formData.vendorId.value"
                                :state="formData.vendorId.isValid"
                                placeholder="Vendor ID"
                                id="form-vendor-id"
                                @input="clearFormVendor"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  variant="primary"
                                  :disabled="formData.vendorId.isValid"
                                  :title="formData.vendorId.isValid ? 'ID already valid' : ''"
                                  @click="validateVendorId"
                                  style="width:4.5rem"
                                >
                                  <b-spinner small v-if="formData.vendorId.isChecking" />
                                  <span v-else>Check</span>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-12">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Vendor Name:"
                            label-for="form-vendor-name"
                            :state="formData.vendorName.isValid"
                          >
                            <b-form-input
                              v-model="formData.vendorName.value"
                              :state="formData.vendorName.isValid"
                              placeholder="Vendor Name"
                              disabled
                              id="form-vendor-name"
                            ></b-form-input>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-12">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Vendor Bank:"
                            label-for="form-vendor-bank"
                            :state="formData.vendorBank.isValid"
                          >
                            <b-form-input
                              v-model="formData.vendorBank.value"
                              :state="formData.vendorBank.isValid"
                              placeholder="Vendor Bank"
                              disabled
                              id="form-vendor-bank"
                            ></b-form-input>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-12">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Vendor Bank Account:"
                            label-for="form-vendor-account"
                            :state="formData.vendorBankAccount.isValid"
                          >
                            <b-form-input
                              v-model="formData.vendorBankAccount.value"
                              :state="formData.vendorBankAccount.isValid"
                              placeholder="Vendor Bank Account"
                              disabled
                              id="form-vendor-account"
                            ></b-form-input>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-12">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Vendor Status:"
                            label-for="form-vendor-status"
                            :state="formData.vendorStatus.isValid"
                          >
                            <b-form-input
                              v-model="formData.vendorStatus.value"
                              :state="formData.vendorStatus.isValid"
                              placeholder="Vendor Status"
                              disabled
                              id="form-vendor-status"
                            ></b-form-input>
                          </b-form-group>
                        </CCol>
                      </CRow>
                    </CCol> -->
                    <CCol class="col-12">
                      <h5 class="custom-header">Data Notaris</h5>
                      <CRow class="mb-2">
                        <CCol class="col-12">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Username:"
                            label-for="form-user-username"
                            :state="formData.username.isValid"
                          >
                            <b-form-input
                              v-model="formData.username.value"
                              :state="formData.username.isValid"
                              maxlength="50"
                              placeholder="Username"
                              disabled
                              id="form-user-username"
                            ></b-form-input>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-12">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="User Full Name:"
                            label-for="form-user-fullname"
                            :state="formData.userFullName.isValid"
                          >
                            <b-form-input
                              v-model="formData.userFullName.value"
                              :state="formData.userFullName.isValid"
                              maxlength="240"
                              placeholder="Nama Lengkap User"
                              disabled
                              id="form-user-fullname"
                            ></b-form-input>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-6">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Tipe"
                            label-for="form-type"
                            :state="formData.type.isValid"
                          >
                            <multiselect 
                              v-model="formData.type.value" 
                              :options="formData.type.options" 
                              :state="formData.type.isValid"
                              :class="{custom_multiselect_invalid: formData.type.isValid === false}"
                              :searchable="false"
                              id="form-type"
                              placeholder="Select an option"
                              :showLabels="false"
                              openDirection="bottom"
                              label="text"
                              track-by="value"
                            >
                              <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                              <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                            </multiselect>
                          </b-form-group>
                        </CCol>
                        <!-- <CCol class="col-4">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Kuota Kontrak:"
                            label-for="form-contract-quota"
                            :state="formData.contractQuota.isValid"
                          >
                            <b-form-input
                              :value="$helper.thousandSeparator(formData.contractQuota.value)"
                              @input="formData.contractQuota.value = $event.toString().replace(/\./g, '')"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                              :state="formData.contractQuota.isValid"
                              placeholder="Kuota Kontrak"
                              type="text"
                              id="form-contract-quota"
                              class="custom-input-height"
                            ></b-form-input>
                          </b-form-group>
                        </CCol> -->
                        <CCol class="col-6">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Status"
                            label-for="form-status"
                            :state="formData.status.isValid"
                          >
                            <multiselect 
                              v-model="formData.status.value" 
                              :options="formData.status.options" 
                              :state="formData.status.isValid"
                              :class="{custom_multiselect_invalid: formData.status.isValid === false}"
                              :searchable="false"
                              id="form-status"
                              placeholder="Select an option"
                              :showLabels="false"
                              openDirection="bottom"
                              label="text"
                              track-by="value"
                            >
                              <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                              <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                            </multiselect>
                          </b-form-group>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol class="col-12 pt-3">
                      <h5 class="custom-header">NPWP, Jamsostek, & SKB</h5>
                      <CRow>
                        <CCol class="col-6">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="No. NPWP:"
                            label-for="form-npwp-no"
                            :state="formData.npwpNo.isValid"
                          >
                            <b-form-input
                              :value="formData.npwpNo.value"
                              @input="formData.npwpNo.value = $helper.parseNpwp($event)"
                              onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 45 || event.charCode == 46"
                              maxlength="20"
                              :state="formData.npwpNo.isValid"
                              placeholder="No. NPWP"
                              id="form-npwp-no"
                            ></b-form-input>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-6">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Jamsostek ID"
                            label-for="form-jst-id"
                            :state="formData.jstId.isValid"
                          >
                            <b-form-input
                              v-model="formData.jstId.value"
                              :state="formData.jstId.isValid"
                              maxlength="50"
                              placeholder="Jamsostek ID"
                              id="form-jst-id"
                            ></b-form-input>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-12">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Nama NPWP:"
                            label-for="form-npwp-name"
                            :state="formData.npwpName.isValid"
                          >
                            <b-form-input
                              v-model="formData.npwpName.value"
                              :state="formData.npwpName.isValid"
                              maxlength="60"
                              placeholder="Nama NPWP"
                              id="form-npwp-name"
                            ></b-form-input>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-12">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Alamat NPWP:"
                            label-for="form-npwp-address"
                            :state="formData.npwpAddress.isValid"
                          >
                            <b-form-textarea
                              v-model="formData.npwpAddress.value"
                              :state="formData.npwpAddress.isValid"
                              maxlength="160"
                              placeholder="Alamat NPWP"
                              id="form-npwp-address"
                              rows="3"
                              max-rows="3"
                            ></b-form-textarea>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-6">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="SKB"
                            label-for="form-skb"
                            :state="formData.skb.isValid"
                          >
                            <multiselect 
                              v-model="formData.skb.value" 
                              :options="formData.skb.options" 
                              :state="formData.skb.isValid"
                              :class="{custom_multiselect_invalid: formData.skb.isValid === false}"
                              :searchable="false"
                              id="form-skb"
                              placeholder="Select an option"
                              :showLabels="false"
                              openDirection="bottom"
                              label="text"
                              track-by="text"
                              @input="clearSkbDate"
                            >
                              <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                              <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                            </multiselect>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-6">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="PPN"
                            label-for="form-ppn"
                            :state="formData.ppn.isValid"
                          >
                            <multiselect 
                              v-model="formData.ppn.value" 
                              :options="formData.ppn.options" 
                              :state="formData.ppn.isValid"
                              :class="{custom_multiselect_invalid: formData.ppn.isValid === false}"
                              :searchable="false"
                              id="form-ppn"
                              placeholder="Select an option"
                              :showLabels="false"
                              openDirection="bottom"
                              label="text"
                              track-by="text"
                            >
                              <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                              <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                            </multiselect>
                          </b-form-group>
                        </CCol>
                        <CCol class="col-12">
                          <b-form-group
                            invalid-feedback="This input is required."
                            label="Masa Berlaku SKB:"
                            label-for="form-valid-start"
                            :state="formData.skbValidFrom.isValid"
                          >
                            <b-input-group>
                              <b-form-datepicker
                                v-model="formData.skbValidFrom.value" 
                                :max="formData.skbValidFrom.maxValue"
                                id="form-valid-start"
                                placeholder="DD/MM/YYYY"
                                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                locale="id"
                                :state="formData.skbValidFrom.isValid"
                                :disabled="formData.skb.value.value === true"
                                @context="onContextSkbValidFrom"
                              ></b-form-datepicker>
                              <b-input-group-append>
                                <b-input-group-text>
                                  ~
                                </b-input-group-text>
                              </b-input-group-append>
                              <b-form-datepicker
                                v-model="formData.skbValidTo.value" 
                                :min="formData.skbValidTo.minValue"
                                :max="formData.skbValidTo.maxValue"
                                id="form-valid-end"
                                placeholder="DD/MM/YYYY"
                                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                locale="id"
                                :state="formData.skbValidTo.isValid"
                                :disabled="formData.skb.value.value === true"
                                @context="onContextSkbValidTo"
                              ></b-form-datepicker>
                            </b-input-group>
                          </b-form-group>
                        </CCol>
                      </CRow>
                    </CCol>
                  </CRow>
                </CCol>
                <CCol class="col-md-12 col-lg-6">
                  <h5 class="custom-header">Data Pribadi</h5>
                  <CRow>
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Nama:"
                        label-for="form-notary-name"
                        :state="formData.notaryName.isValid"
                      >
                        <b-form-input
                          v-model="formData.notaryName.value"
                          :state="formData.notaryName.isValid"
                          maxlength="70"
                          placeholder="Nama"
                          id="form-notary-name"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Tanggal Lahir:"
                        label-for="form-notary-bdate"
                        :state="formData.notaryBdate.isValid"
                      >
                        <b-form-datepicker
                          v-model="formData.notaryBdate.value" 
                          :max="formData.notaryBdate.maxValue"
                          id="form-notary-bdate"
                          placeholder="DD/MM/YYYY"
                          :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                          locale="id"
                          :state="formData.notaryBdate.isValid"
                        ></b-form-datepicker>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Alamat 1:"
                        label-for="form-notary-addr1"
                        :state="formData.notaryAddr1.isValid"
                      >
                      <b-form-textarea
                        v-model="formData.notaryAddr1.value"
                        :state="formData.notaryAddr1.isValid"
                        maxlength="120"
                        placeholder="Alamat 1"
                        id="form-notary-addr1"
                        rows="3"
                        max-rows="3"
                      ></b-form-textarea>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-12">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Alamat 2:"
                        label-for="form-notary-addr2"
                        :state="formData.notaryAddr2.isValid"
                      >
                        <b-form-textarea
                          v-model="formData.notaryAddr2.value"
                          :state="formData.notaryAddr2.isValid"
                          maxlength="100"
                          placeholder="Alamat 2"
                          id="form-notary-addr2"
                          rows="3"
                          max-rows="3"
                        ></b-form-textarea>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Kota:"
                        label-for="form-notary-city"
                        :state="formData.notaryCity.isValid"
                      >
                        <multiselect 
                          v-model="formData.notaryCity.value" 
                          :options="formData.notaryCity.options" 
                          class="mb-0"
                          :class="{custom_multiselect_invalid: formData.notaryCity.isValid === false}"
                          placeholder="Select an option"
                          :showLabels="false"
                          :loading="!formData.notaryCity.isLoaded"
                          openDirection="bottom"
                          label="name"
                          track-by="code"
                          :internalSearch="false"
                          :multiple="false"
                          :preserveSearch="false"
                          @search-change="populateCity"
                          @input="onInputCity"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.name }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.name }}</template>
                          <template slot="noResult">No elements found.</template>
                          <template slot="afterList" v-if="formData.notaryCity.currentPage < formData.notaryCity.totalPages">
                            <div class="text-center custom-cursor-clickable p-2" @click="appendCity" v-if="formData.notaryCity.isLoaded">
                              <span class="text-muted">Load More</span>
                            </div>
                            <div class="text-center" v-else>
                              <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                            </div>
                          </template>
                        </multiselect>
                        <!-- <b-form-input
                          v-model="formData.notaryCity.value"
                          :state="formData.notaryCity.isValid"
                          maxlength="100"
                          placeholder="Kota"
                          id="form-notary-city"
                        ></b-form-input> -->
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Kode Pos:"
                        label-for="form-notary-zip"
                        :state="formData.notaryZip.isValid"
                      >
                        <multiselect 
                          v-model="formData.notaryZip.value" 
                          :options="formData.notaryZip.options" 
                          class="mb-0"
                          :class="{custom_multiselect_invalid: formData.notaryZip.isValid === false}"
                          placeholder="Select an option"
                          :showLabels="false"
                          :loading="!formData.notaryZip.isLoaded"
                          openDirection="bottom"
                          label="name"
                          track-by="code"
                          :internalSearch="false"
                          :multiple="false"
                          :preserveSearch="false"
                          @search-change="populateZipcode"
                          @input="onInputZipcode"
                        >
                          <template slot="singleLabel" slot-scope="props">{{ props.option.name }}</template>
                          <template slot="option" slot-scope="props">{{ props.option.name }}</template>
                          <template slot="noResult">No elements found.</template>
                          <template slot="afterList" v-if="formData.notaryZip.currentPage < formData.notaryZip.totalPages">
                            <div class="text-center custom-cursor-clickable p-2" @click="appendZipcode" v-if="formData.notaryZip.isLoaded">
                              <span class="text-muted">Load More</span>
                            </div>
                            <div class="text-center" v-else>
                              <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                            </div>
                          </template>
                        </multiselect>
                        <!-- <b-form-input
                          :value="formData.notaryZip.value"
                          @input="formData.notaryZip.value = $helper.parseNumber($event)"
                          :key="formData.notaryZip.key"
                          maxlength="5"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          :state="formData.notaryZip.isValid"
                          placeholder="Kode Pos"
                          id="form-notary-zip"
                        ></b-form-input> -->
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Telephone 1:"
                        label-for="form-notary-tel1"
                        :state="formData.notaryTel1.isValid"
                      >
                        <b-form-input
                          :value="formData.notaryTel1.value"
                          @input="formData.notaryTel1.value = $helper.parseNumber($event)"
                          :key="formData.notaryTel1.key"
                          maxlength="30"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          :state="formData.notaryTel1.isValid"
                          placeholder="Telephone 1"
                          id="form-notary-tel1"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Telephone 2:"
                        label-for="form-notary-tel2"
                        :state="formData.notaryTel2.isValid"
                      >
                        <b-form-input
                          :value="formData.notaryTel2.value"
                          @input="formData.notaryTel2.value = $helper.parseNumber($event)"
                          :key="formData.notaryTel2.key"
                          maxlength="30"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          :state="formData.notaryTel2.isValid"
                          placeholder="Telephone 2"
                          id="form-notary-tel2"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Handphone 1:"
                        label-for="form-notary-phone1"
                        :state="formData.notaryPhone1.isValid"
                      >
                        <b-form-input
                          :value="formData.notaryPhone1.value"
                          @input="formData.notaryPhone1.value = $helper.parseNumber($event)"
                          :key="formData.notaryPhone1.key"
                          maxlength="15"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          :state="formData.notaryPhone1.isValid"
                          placeholder="Handphone 1"
                          id="form-notary-phone1"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="Handphone 2:"
                        label-for="form-notary-phone2"
                        :state="formData.notaryPhone2.isValid"
                      >
                        <b-form-input
                          :value="formData.notaryPhone2.value"
                          @input="formData.notaryPhone2.value = $helper.parseNumber($event)"
                          :key="formData.notaryPhone2.key"
                          maxlength="15"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          :state="formData.notaryPhone2.isValid"
                          placeholder="Handphone 2"
                          id="form-notary-phone2"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        :invalid-feedback="formData.notaryEmail.feedback"
                        label="Email:"
                        label-for="form-notary-email"
                        :state="formData.notaryEmail.isValid"
                      >
                        <b-form-input
                          v-model="formData.notaryEmail.value"
                          :state="formData.notaryEmail.isValid"
                          maxlength="50"
                          placeholder="Email"
                          id="form-notary-email"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                    <CCol class="col-6">
                      <b-form-group
                        invalid-feedback="This input is required."
                        label="FAX:"
                        label-for="form-notary-fax"
                        :state="formData.notaryFax.isValid"
                      >
                        <b-form-input
                          :value="formData.notaryFax.value"
                          @input="formData.notaryFax.value = $helper.parseNumber($event)"
                          :key="formData.notaryFax.key"
                          maxlength="30"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          :state="formData.notaryFax.isValid"
                          placeholder="FAX"
                          id="form-notary-fax"
                        ></b-form-input>
                      </b-form-group>
                    </CCol>
                  </CRow>
                </CCol>
                <CCol class="col-12 pt-3">
                  <CButton color="primary" class="float-right" style="width:7rem" type="submit" :disabled="isSubmitting" @click="editNotary">
                    <b-spinner small v-if="isSubmitting" />
                    <span v-else>Submit</span>
                  </CButton>
                  <b-btn variant="secondary" class="mr-2 float-right" @click="$router.push({name: 'Notaris List'})">Back</b-btn>
                  <!-- <b-btn @click="testAction">Test</b-btn> -->
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CForm>
    <CCard class="custom-card ml-2 mr-2" v-if="$helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO'])">
      <CCardBody class="px-0 pb-0">
        <CRow class="mx-2">
          <CCol class="col-9 col-xs-9 col-sm-9 col-md-8 col-lg-8 col-xl-6">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <!-- <multiselect 
                    :allow-empty="false"
                    v-model="filter.value" 
                    :options="filter.options"
                    :searchable="false"
                    id="filter-table-notary"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect> -->
                  <b-form-select v-model="filter.value" :options="filter.options" @change="clearFilterValue"></b-form-select>
                </b-input-group-prepend>
                <b-form-datepicker
                  v-model="filter.filterDate" 
                  placeholder="DD/MM/YYYY"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  locale="id"
                  v-if="filter.value == 'mouDate' || filter.value == 'startDate' || filter.value == 'endDate'"
                ></b-form-datepicker>
                <b-form-select v-else-if="filter.value == 'status'" v-model="filter.filterSearch" :options="filter.optionsStatus"></b-form-select>
                <b-form-select v-else-if="filter.value == 'mouType'" v-model="filter.filterSearch" :options="filter.optionsType"></b-form-select>
                <b-form-input v-else maxlength="50" v-model="filter.filterSearch" autocomplete="off" placeholder="Search"></b-form-input>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" title="Filter Tabel MoU" :disabled="!mouTable.isLoaded" @click="filterMouTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
          <CCol class="col-3 col-xs-3 col-sm-3 col-md-4 col-lg-4 col-xl-6">
            <CButton color="primary" class="float-right" @click="createMou()">
              Add <FaIcon icon="plus" />
            </CButton>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <h5 class="custom-header">Data MoU</h5>
            <b-table striped hover show-empty
              responsive="xl"
              :items="mouTable.items"
              :fields="mouTable.fields"
              :busy="!mouTable.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onMouTableSortChanged"
            >
              <template #cell(mouNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(mouDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(officeName)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(status)="row">
                {{ row.item.status == 'AC' ? "Aktif" : "Nonaktif" }}
              </template>
              <template #cell(mouType)="row">
                {{ row.item.mouType == 'I' ? "Individu" : "Perusahaan" }}
              </template>
              <template #cell(startDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(endDate)="row">
                {{ $helper.showData(row.value, "shortDate") }}
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="primary" class="btn-icon mr-1 custom-button-action" style="width:2.22rem" :disabled="row.item.isFetching" @click="editMou(row.index)">
                  <b-spinner small v-if="row.item.isFetching" />
                  <b-icon icon="eye" title="Detail MoU" v-else></b-icon>
                </CButton>
                <CButton size="sm" color="danger" class="custom-button-action" style="width:5.5rem" @click="toggleStatus(row.index)" :disabled="row.item.isToggling" v-if="row.item.status == 'AC'">
                  <b-spinner small v-if="row.item.isToggling" />
                  <span v-else>Deaktivasi</span>
                </CButton>
                <CButton size="sm" color="success" class="custom-button-action" style="width:5.5rem" @click="toggleStatus(row.index)" :disabled="row.item.isToggling" v-else>
                  <b-spinner small v-if="row.item.isToggling" />
                  <span v-else>Aktivasi</span>
                </CButton>
              </template>
              <template slot="empty">
                <div v-if="!mouTable.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="mouTable.totalRows" :page="mouTable.currentPage" @limit-change="onMouTableLimitChange" @page-change="onMouTablePageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <!-- <b-modal
      v-model="modalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
      size="lg"
    >
      <CForm>
        <CRow>
          <CCol class="col-12 col-lg-6">
            <b-form-group
              invalid-feedback="This input is required."
              label="Tipe MoU"
              label-for="modal-mou-type"
              :state="modalData.mouType.isValid"
            >
              <multiselect 
                v-model="modalData.mouType.value" 
                :options="modalData.mouType.options" 
                :state="modalData.mouType.isValid"
                :class="{custom_multiselect_invalid: modalData.mouType.isValid === false}"
                :searchable="false"
                id="modal-mou-type"
                placeholder="Select an option"
                :showLabels="false"
                openDirection="bottom"
                label="text"
                track-by="value"
              >
                <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                <template slot="option" slot-scope="props">{{ props.option.text }}</template>
              </multiselect>
            </b-form-group>
          </CCol>
          <CCol class="col-12 col-lg-6">
            <b-form-group
              invalid-feedback="This input is required."
              label="Office"
              label-for="modal-mou-office"
              :state="modalData.officeCode.isValid"
            >
              <multiselect 
                v-model="modalData.officeCode.value" 
                :options="modalData.officeCode.options" 
                :state="modalData.officeCode.isValid"
                :class="{custom_multiselect_invalid: modalData.officeCode.isValid === false}"
                id="modal-mou-office"
                placeholder="Select an option"
                :showLabels="false"
                :loading="!modalData.officeCode.isLoaded"
                openDirection="bottom"
                label="nameFull"
                track-by="officeCode"
                :internalSearch="false"
                :preserveSearch="true"
                @search-change="populateModalOffice"
              >
                <template slot="singleLabel" slot-scope="props">{{ props.option.nameFull }}</template>
                <template slot="option" slot-scope="props">{{ props.option.nameFull }}</template>
                <template slot="noResult">No elements found.</template>
                <template slot="afterList" v-if="modalData.officeCode.currentPage < modalData.officeCode.totalPages">
                  <div class="text-center custom-cursor-clickable p-2" @click="appendModalOffice" v-if="modalData.officeCode.isLoaded">
                    <span class="text-muted">Load More</span>
                  </div>
                  <div class="text-center" v-else>
                    <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                  </div>
                </template>
              </multiselect>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="col-12 col-lg-6">
            <CRow>
              <CCol class="col-12">
                <b-form-group
                  invalid-feedback="This input is required."
                  label="Masa Berlaku MoU:"
                  label-for="modal-mou-startDate"
                  :state="modalData.startDate.isValid"
                >
                  <b-input-group>
                    <b-form-datepicker
                      v-model="modalData.startDate.value" 
                      :max="modalData.startDate.maxValue"
                      id="modal-mou-startDate"
                      placeholder="DD/MM/YYYY"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      locale="id"
                      :state="modalData.startDate.isValid"
                      @context="onContextMouStartDate"
                    ></b-form-datepicker>
                    <b-input-group-append>
                      <b-input-group-text>
                        ~
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-datepicker
                      v-model="modalData.endDate.value" 
                      :min="modalData.endDate.minValue"
                      :max="modalData.endDate.maxValue"
                      id="modal-mou-endDate"
                      placeholder="DD/MM/YYYY"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      locale="id"
                      :state="modalData.endDate.isValid"
                      @context="onContextMouEndDate"
                    ></b-form-datepicker>
                  </b-input-group>
                </b-form-group>
              </CCol>
              <CCol class="col-12">
                <b-form-group
                  invalid-feedback="This input is required."
                  label="Tanggal Pembuatan MoU:"
                  label-for="modal-mou-date"
                  :state="modalData.mouDate.isValid"
                >
                  <b-form-datepicker
                    v-model="modalData.mouDate.value" 
                    id="modal-mou-date"
                    placeholder="DD/MM/YYYY"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    locale="id"
                    :state="modalData.mouDate.isValid"
                  ></b-form-datepicker>
                </b-form-group>
              </CCol>
            </CRow>
          </CCol>
          <CCol class="col-12 col-lg-6">
            <b-form-group
              invalid-feedback="This input is required."
              label="Deskripsi MoU:"
              label-for="modal-mou-description"
              :state="modalData.description.isValid"
            >
              <b-form-textarea
                v-model="modalData.description.value"
                :state="modalData.description.isValid"
                placeholder="Deskripsi MoU"
                id="modal-mou-description"
                rows="4"
                max-rows="4"
              ></b-form-textarea>
            </b-form-group>
          </CCol>
          <CCol class="col-12">
            <b-table
              striped
              :items="modalData.bussUnitTable.items"
              :fields="modalData.bussUnitTable.fields"
            >
              <template #cell(bussUnit)="row">
                <b-form-group
                  invalid-feedback="This input is required."
                  :state="row.item.bussUnit.isValid"
                  class="mb-0"
                >
                  <multiselect 
                    v-model="row.item.bussUnit.value" 
                    :options="modalData.bussUnitAvailOptions" 
                    :state="row.item.bussUnit.isValid"
                    :class="{custom_multiselect_invalid: row.item.bussUnit.isValid === false}"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                    @input="onChangeBussUnit"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.value.bussUnit + " - " + (props.option.value.transType == "F" ? "Fiducia" : "Roya") }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="noResult">No elements found.</template>
                  </multiselect>
                </b-form-group>
              </template>
              <template #cell(chargeAmount)="row">
                <b-form-group
                  invalid-feedback="This input is required."
                  :state="row.item.chargeAmount.isValid"
                  class="mb-0"
                >
                  <b-form-input
                    :value="$helper.thousandSeparator(row.item.chargeAmount.value)"
                    @input="row.item.chargeAmount.value = $event.toString().replace(/\./g, '')"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13"
                    :state="row.item.chargeAmount.isValid"
                    placeholder="Charge Amount"
                    type="text"
                    class="custom-input-height"
                  ></b-form-input>
                </b-form-group>
              </template>
              <template #cell(status)="row">
                <b-form-group
                  invalid-feedback="This input is required."
                  :state="row.item.status.isValid"
                  class="mb-0"
                >
                  <multiselect 
                    v-model="row.item.status.value" 
                    :options="row.item.status.options" 
                    :state="row.item.status.isValid"
                    :class="{custom_multiselect_invalid: row.item.status.isValid === false}"
                    :searchable="false"
                    placeholder="Select an option"
                    :showLabels="false"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  </multiselect>
                </b-form-group>
              </template>
              <template #cell(action)="row">
                <b-button variant="danger" size="sm" title="Remove Row" @click="removeMouBussUnit(row.index)" v-if="isShowRemoveButton(row.item.id)"><CIcon name="cil-minus"/></b-button>
              </template>
              <template #head(action)>
                <b-button variant="primary" size="sm" title="Add New Row" @click="addMouBussUnit"><CIcon name="cil-plus"/></b-button>
              </template>
            </b-table>
          </CCol>
        </CRow>
        <CRow class="mt-5 float-right">
          <CCol class="col-12">
            <b-btn variant="secondary" class="mr-3" @click="modalData.isShowing = false">Cancel</b-btn>
            <b-btn variant="primary" type="submit" style="width:4rem" :disabled="modalData.isSubmitting" @click="saveMou">
              <b-spinner small v-if="modalData.isSubmitting" />
              <span v-else>Save</span>
            </b-btn>
          </CCol>
        </CRow>
      </CForm>
    </b-modal> -->
  </CContainer>
</template>


<script>
export default {
  name: 'NotarisEdit',
  data() {
    const today = this.$moment().format('YYYY-MM-DD')
    const periodFormat = /[0-9]{4}-[0-9]{2}-[0-9]{2}/g
    const emailFormat = /^\S+@\S+\.\S+$/
    return {
      citySelectedfromZipcode: true,
      isSubmitting: false,
      isLoading: true,
      filter: {
        value: "mouNo",
        options: [
          { value:"mouNo", text: "No. MoU" },
          { value:"mouDate", text: "Tanggal MoU" },
          { value:"officeName", text: "Nama Office" },
          { value:"status", text: "Status" },
          { value:"mouType", text: "Tipe" },
          { value:"startDate", text: "Tanggal Mulai" },
          { value:"endDate", text: "Tanggal Akhir" }
        ],
        optionsStatus: [
          { value:"ac", text: "Aktif" },
          { value:"na", text:"Nonaktif" }
        ],
        optionsType: [
          { value:"i", text: "Individu" },
          { value:"c", text:"Perusahaan" }
        ],
        filterSearch: '',
        filterDate: '',
        filterType: '',
        filterValue: ''
      },
      mouTable: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "mouNo", label: "No. MoU", sortable: true},
          {key: "mouDate", label: "Tanggal MoU", sortable: true},
          {key: "officeName", label: "Nama Office", sortable: true},
          {key: "status", label: "Status", sortable: true},
          {key: "mouType", label: "Tipe", sortable: true},
          {key: "startDate", label: "Tanggal Mulai", sortable: true},
          {key: "endDate", label: "Tanggal Akhir", sortable: true},
          { key: "action", label: "Aksi", sortable: false, class:"custom-column-action-notary" }
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },
      formData: {
        type: {
          value: '',
          isValid: null,
          isRequired: true,
          // hardcoded options
          options: [
            { value: '1', text: "Badan Usaha" },
            { value: '2', text: "Perorangan" }
          ],
          payloadKey: "type"
        },
        status: {
          value: '',
          isValid: null,
          isRequired: true,
          // hardcoded options
          options: [
            { value: 'AC', text: "Aktif" },
            { value: 'NA', text: "Nonaktif" }
          ],
          payloadKey: "status"
        },
        // office: {
        //   /*
        //     "nameFull": "string",
        //     "nameShort": "string",
        //     "officeCode": "string
        //   */
        //   value: '',
        //   isLoaded: false,
        //   isValid: null,
        //   isRequired: true,
        //   options: [],
        //   currentPage: 1,
        //   perPage: 10,
        //   totalRows: 0,
        //   totalPages: 0,
        //   lastQuery: '',
        //   payloadKey: "officeCode"
        // },
        // contractQuota: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "contractQuota"
        // },
        username: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "username"
        },
        userFullName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "userFullName"
        },
        // vendorId: {
        //   value: '',
        //   isChecking: false,
        //   isValid: null,
        //   isRequired: true,
        //   feedback: 'Vendor ID is not valid.',
        //   payloadKey: "vendorId"
        // },
        // vendorName: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "vendorName"
        // },
        // vendorBank: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "vendorBank"
        // },
        // vendorBankAccount: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "vendorBankAccount"
        // },
        // vendorStatus: {
        //   value: '',
        //   isValid: null,
        //   isRequired: true,
        //   payloadKey: "vendorStatus"
        // },
        npwpNo: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "npwpNo"
        },
        jstId: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "jamsostekId"
        },
        npwpName: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "npwpName"
        },
        npwpAddress: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "npwpAddress"
        },
        skb: {
          value: { value: false, text: "True" },
          isValid: null,
          isRequired: true,
          // intentionally reversed
          options: [
            { value: false, text: "True" },
            { value: true, text: "False" }
          ],
          payloadKey: "pph"
        },
        ppn: {
          value: '',
          isValid: null,
          isRequired: true,
          options: [
            { value: true, text: "True" },
            { value: false, text: "False" }
          ],
          payloadKey: "ppn"
        },
        skbValidFrom: {
          value: today,
          isValid: null,
          isRequired: true,
          maxValue: '',
          payloadKey: "nonPphStartdate"
        },
        skbValidTo: {
          value: today,
          isValid: null,
          isRequired: true,
          minValue: '',
          maxValue: '',
          payloadKey: "nonPphEnddate"
        },
        notaryName: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "name"
        },
        notaryBdate: {
          value: today,
          isValid: null,
          isRequired: true,
          maxValue: today,
          payloadKey: "birthDate"
        },
        notaryAddr1: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "address1"
        },
        notaryAddr2: {
          value: '',
          isValid: null,
          isRequired: false,
          payloadKey: "address2"
        },
        notaryCity: {
          value: null,
          options: [],
          isLoaded: false,
          isValid: null,
          isRequired: true,
          payloadKey: "city",
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
        },
        notaryZip: {
          value: null,
          options: [],
          isLoaded: false,
          isValid: null,
          key: 'notaryZip-0',
          isRequired: true,
          payloadKey: "zipcode",
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
        },
        notaryTel1: {
          value: '',
          isValid: null,
          key: 'notaryTel1-0',
          isRequired: true,
          payloadKey: "tel1"
        },
        notaryTel2: {
          value: '',
          isValid: null,
          key: 'notaryTel2-0',
          isRequired: false,
          payloadKey: "tel2"
        },
        notaryPhone1: {
          value: '',
          isValid: null,
          key: 'notaryPhone1-0',
          isRequired: true,
          payloadKey: "mobile1"
        },
        notaryPhone2: {
          value: '',
          isValid: null,
          key: 'notaryPhone2-0',
          isRequired: false,
          payloadKey: "mobile2"
        },
        notaryFax: {
          value: '',
          isValid: null,
          key: 'notaryFax-0',
          isRequired: false,
          payloadKey: "fax"
        },
        notaryEmail: {
          value: '',
          feedback: 'This input is required.',
          format: emailFormat,
          isValid: null,
          isRequired: true,
          payloadKey: "email"
        },
        userId: {
          value: '',
          payloadKey: "userId"
        }
      },
      // modalData: {
      //   isShowing: false,
      //   isSubmitting: false,
      //   mouId: '',
      //   description: {
      //     value: '',
      //     isValid: null,
      //     isRequired: true,
      //     payloadKey: "description"
      //   },
      //   startDate: {
      //     value: '',
      //     isValid: null,
      //     isRequired: true,
      //     maxValue: '',
      //     payloadKey: "startDate"
      //   },
      //   endDate: {
      //     value: '',
      //     isValid: null,
      //     isRequired: true,
      //     minValue: '',
      //     maxValue: '',
      //     payloadKey: "endDate"
      //   },
      //   mouDate: {
      //     value: '',
      //     isValid: null,
      //     isRequired: true,
      //     payloadKey: "mouDate"
      //   },
      //   mouType: {
      //     value: '',
      //     isValid: null,
      //     isRequired: true,
      //     // hardcoded options
      //     options: [
      //       { value: 'I', text: "Individu" },
      //       { value: 'C', text: "Perusahaan" }
      //     ],
      //     payloadKey: "mouType"
      //   },
      //   officeCode: {
      //     /*
      //       "nameFull": "string",
      //       "nameShort": "string",
      //       "officeCode": "string
      //     */
      //     value: '',
      //     isLoaded: false,
      //     isValid: null,
      //     isRequired: true,
      //     options: [],
      //     currentPage: 1,
      //     perPage: 10,
      //     totalRows: 0,
      //     totalPages: 0,
      //     lastQuery: '',
      //     payloadKey: "officeCode"
      //   },
      //   status: {
      //     value: '',
      //     payloadKey: "status"
      //   },
      //   // globally keeps track of available business unit options
      //   bussUnitAvailOptions: [],
      //   // combination of bussUnit and transType dropdown
      //   bussUnitTemplate: {
      //     value: '',
      //     isValid: null,
      //     isRequired: true,
      //     payloadKey: {
      //       bussUnit: "bussUnit",
      //       transType: "transType"
      //     }
      //   },
      //   chargeAmountTemplate: {
      //     value: '',
      //     isValid: null,
      //     isRequired: true,
      //     payloadKey: "chargeAmount"
      //   },
      //   bussUnitStatusTemplate: {
      //     value: '',
      //     isValid: null,
      //     isRequired: true,
      //     // hardcoded options
      //     options: [
      //       { value: "AC", text: "Aktif" },
      //       { value: "NA", text: "Nonaktif" }
      //     ],
      //     payloadKey: "status"
      //   },
      //   bussUnitTable: {
      //     fields: [
      //       // bussUnit + transType
      //       {key: "bussUnit", label: "Business Unit"},
      //       {key: "chargeAmount", label: "Charge Amount"},
      //       {key: "status", label: "Status"},
      //       {key: "action", label: "Aksi"}
      //     ],
      //     items: [],
      //     sortBy: null,
      //     sortDesc: true,
      //     currentPage: 1,
      //     perPage: 10,
      //     totalRows: 0,
      //     totalPages: 0
      //   }
      // }
    }
  },
  methods: {

    // testAction() {
    //   console.warn(this.formData.notaryZip)
    // },

    onInputCity() {
      this.populateZipcode()
      if (!this.$helper.isEmpty(this.formData.notaryCity.value)) {
        // City selected
        if (!this.$helper.isEmpty(this.formData.notaryZip.value)) {
          // Zipcode is already selected
          if (!this.checkZipcode()) {
            // Selected zipcode doesn't aligns with the city
            this.formData.notaryZip.value = null
          }
        }
      } else{
        // City is deselected
        this.formData.notaryZip.value = null
      }

      if (this.citySelectedfromZipcode) {
        // Remove the first element of option
        this.formData.notaryCity.options.shift()
        this.citySelectedfromZipcode = false
      }
    },

    onInputZipcode() {
      if (!this.$helper.isEmpty(this.formData.notaryZip.value) && this.$helper.isEmpty(this.formData.notaryCity.value)) {
        // Zipcode selected but city is still empty
        // Automatically assign city based on zipcode
        let obj = {
          code: this.formData.notaryZip.value.cityCode,
          name: this.formData.notaryZip.value.cityName,
        }
        this.formData.notaryCity.value = obj
        if (this.citySelectedfromZipcode) {
          // City is already selected previously
          this.formData.notaryCity.options[0] = obj
        } else{
          // City has not been specified through zipcode
          this.formData.notaryCity.options.unshift(obj)
          this.citySelectedfromZipcode = true
        }
      }
    },

    checkZipcode() {
      if (this.formData.notaryCity.value.code == this.formData.notaryZip.value.cityCode) {
        return true
      } else{
        return false
      }
    },

    appendZipcode() {
      this.formData.notaryZip.isLoaded = false
      // URL builder
      let getUrl = "/zipcode/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.notaryZip.currentPage, this.formData.notaryZip.perPage)
      if(this.formData.notaryZip.lastQuery !== ""){
        params['filterType'] = "zipcode"
        params['filterValue'] = this.formData.notaryZip.lastQuery
      }
      if (!this.$helper.isEmpty(this.formData.notaryCity.value)) {
        params['filterCity'] = this.formData.notaryCity.value.code
      }
      params['asc'] = "true"
      params['sortBy'] = "zipcode"

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              let obj = {
                ...response.data.data.data[i],
                code: response.data.data.data[i].zipcode,
                name: response.data.data.data[i].zipcode
              }
              this.formData.notaryZip.options.push(obj)
            }
            this.formData.notaryZip.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.notaryZip.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    populateZipcode(query = "") {
      this.formData.notaryZip.isLoaded = false
      this.formData.notaryZip.totalPages = 0
      this.formData.notaryZip.totalRows = 0
      this.formData.notaryZip.currentPage = 1
      this.formData.notaryZip.lastQuery = query
      // URL builder
      let getUrl = "/zipcode/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.notaryZip.currentPage - 1, this.formData.notaryZip.perPage)
      if(query !== ""){
        params['filterType'] = "zipcode"
        params['filterValue'] = query
      }
      if (!this.$helper.isEmpty(this.formData.notaryCity.value)) {
        params['filterCity'] = this.formData.notaryCity.value.code
      }
      params['asc'] = "true"
      params['sortBy'] = "zipcode"

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.formData.notaryZip.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              let obj = {
                ...response.data.data.data[i],
                code: response.data.data.data[i].zipcode,
                name: response.data.data.data[i].zipcode
              }
              this.formData.notaryZip.options.push(obj)
            }
            this.formData.notaryZip.totalRows = response.data.data.totalElements
            this.formData.notaryZip.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kode Pos Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.notaryZip.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendCity() {
      this.formData.notaryCity.isLoaded = false
      // URL builder
      let getUrl = "/city/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.notaryCity.currentPage, this.formData.notaryCity.perPage)
      if(this.formData.notaryCity.lastQuery !== ""){
        params['filterType'] = "name"
        params['filterValue'] = this.formData.notaryCity.lastQuery
      }
      params['asc'] = "true"
      params['sortBy'] = "name"

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              if (!this.$helper.objectHasSameData(response.data.data.data[i], this.formData.notaryCity.value)) {
                this.formData.notaryCity.options.push(response.data.data.data[i])
              }
            }
            this.formData.notaryCity.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.notaryCity.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    populateCity(query = "") {
      this.formData.notaryCity.isLoaded = false
      this.formData.notaryCity.totalPages = 0
      this.formData.notaryCity.totalRows = 0
      this.formData.notaryCity.currentPage = 1
      this.formData.notaryCity.lastQuery = query
      // URL builder
      let getUrl = "/city/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.formData.notaryCity.currentPage - 1, this.formData.notaryCity.perPage)
      if(query !== ""){
        params['filterType'] = "name"
        params['filterValue'] = query
      }
      params['asc'] = "true"
      params['sortBy'] = "name"

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.formData.notaryCity.options = []
            if (!this.$helper.isEmpty(this.formData.notaryCity.value)) this.formData.notaryCity.options.push(this.formData.notaryCity.value)
            for(let i = 0; i < response.data.data.data.length; i++){
              if (!this.$helper.objectHasSameData(response.data.data.data[i], this.formData.notaryCity.value)) {
                this.formData.notaryCity.options.push(response.data.data.data[i])
              }
            }
            this.formData.notaryCity.totalRows = response.data.data.totalElements
            this.formData.notaryCity.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Kota Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.formData.notaryCity.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    createMou() {
      this.$router.push({ name: 'MOU Add', params: { notarisId: this.$route.params.notarisId } })
    },

    editMou(index) {
      
      this.$router.push({ name: 'MOU Edit', params: { notarisId: this.$route.params.notarisId, mouId: this.mouTable.items[index].mouId } })
    },

    // update datepicker valid dates on change
    onContextSkbValidFrom() {
      this.formData.skbValidTo.minValue = this.formData.skbValidFrom.value
    },
    onContextSkbValidTo() {
      this.formData.skbValidFrom.maxValue = this.formData.skbValidTo.value
    },
    onContextMouStartDate() {
      this.modalData.endDate.minValue = this.modalData.startDate.value
    },
    onContextMouEndDate() {
      this.modalData.startDate.maxValue = this.modalData.endDate.value
    },
    // for updating specific input elements on change
    updateKey(keyName){
      return keyName + "-" + this.keyIncrement++
    },
    // update table with server-side processing on change
    onMouTableLimitChange(newPerPage) {
      this.mouTable.perPage = newPerPage
      // only fetch data when roles apply
      this.getMouTableItems()
    },
    onMouTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getMouTableItems(newPage)
    },
    onMouTableSortChanged(ctx) {
      this.mouTable.sortBy = ctx.sortBy
      this.mouTable.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getMouTableItems(this.mouTable.currentPage)
    },
    // // check and disable all selected options from list
    // onChangeBussUnit(){
    //   // enable all options
    //   for(let i = 0; i < this.modalData.bussUnitAvailOptions.length; i++){
    //     this.modalData.bussUnitAvailOptions[i].$isDisabled = false
    //   }
    //   // disable all already-selected options
    //   for(let i = 0; i < this.modalData.bussUnitAvailOptions.length; i++){
    //     for(let j = 0; j < this.modalData.bussUnitTable.items.length; j++){
    //       // if business unit in row is not empty
    //       if(!this.$helper.isEmpty(this.modalData.bussUnitTable.items[j].bussUnit.value)){
    //         // if current option is already selected in a row
    //         if(this.modalData.bussUnitAvailOptions[i].value.bussUnit == this.modalData.bussUnitTable.items[j].bussUnit.value.value.bussUnit && this.modalData.bussUnitAvailOptions[i].value.transType == this.modalData.bussUnitTable.items[j].bussUnit.value.value.transType){
    //           // disable already selected option
    //           this.modalData.bussUnitAvailOptions[i].$isDisabled = true
    //         }
    //       }
    //     }
    //   }
    // },
    clearFilterValue() {
      this.filter.filterSearch = ''
      this.filter.filterType = ''
      this.filter.filterValue = ''
      this.filter.filterDate = ''
      if (this.filter.value == 'status') {
        this.filter.filterSearch = 'ac'
      }
      else if (this.filter.value == 'mouType') {
        this.filter.filterSearch = 'i'
      }
    },
    filterMouTable(event){
      event.preventDefault()
      this.filter.filterType = this.filter.value
      // use datepicker value if type date
      if(this.filter.value == 'mouDate' || this.filter.value == 'startDate' || this.filter.value == 'endDate'){
        this.filter.filterValue = this.filter.filterDate
      }
      // use text value otherwise
      else{
        this.filter.filterValue = this.filter.filterSearch
      }
      // reload table
      this.getMouTableItems()
    },
    // get paginated table contents from server-side
    getMouTableItems(page = 1) {
      if(isNaN(page)) {
        this.mouTable.currentPage = 1
      }
      else {
        this.mouTable.currentPage = page
      }
      // URL builder
      let getUrl = "/mou/getAllByNotary"
      
      let params = this.$helper.getBasePagedQuery(this.mouTable.currentPage - 1, this.mouTable.perPage)
      params['notaryId'] = this.$route.params.notarisId
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.mouTable.sortBy != null) {
        params['sortBy'] = this.mouTable.sortBy
        params['asc'] = !this.mouTable.sortDesc
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.mouTable.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            sessionStorage.setItem("filterMouType" + String(this.$route.params.notarisId), this.filter.filterType)
            sessionStorage.setItem("filterMouValue" + String(this.$route.params.notarisId), this.filter.filterValue)
            this.mouTable.items = response.data.data.data.map(item => {
              return {
                "mouNo": item.mouNo,
                "mouId": item.mouId,
                "mouDate": item.mouDate,
                "officeName": item.officeName,
                "status": item.status,
                "mouType": item.mouType,
                "startDate": item.startDate,
                "endDate": item.endDate,
                "isFetching": false,
                "isToggling": false
              }
            })
            this.mouTable.totalRows = response.data.data.totalElements
            this.mouTable.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar MoU Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar MoU Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar MoU Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.mouTable.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    toggleStatus(idx) {
      let postUrl = "/mou/toggleStatus"
      let payload = new FormData()
      payload.append("mouId", this.mouTable.items[idx].mouId)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        // use index to properly update table row after manipulation
        this.mouTable.items[idx].isToggling = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            if(this.mouTable.items[idx].status == "AC") this.mouTable.items[idx].status = "NA"
            else this.mouTable.items[idx].status = "AC"
            this.$helper.toastSuccess(this, (this.mouTable.items[idx].status == "AC" ? "Aktivasi" : "Deaktivasi") + " MoU Berhasil! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
          else{
            this.$helper.toastError(this, "Ubah Status MoU Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Ubah Status MoU Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Ubah Status MoU Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.mouTable.items[idx].isToggling = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // // displays MoU Add/Edit modal
    // showMouModal(idx = -1){
    //   // clear modal, get data from BE, and show if Edit button is pressed
    //   if(idx !== -1){
    //     this.modalData.mouId = this.mouTable.items[idx].mouId
    //     let getUrl = "/mou/getOneById"
    //     getUrl += "?mouId=" + this.modalData.mouId
    //     // only send axios request if role is valid
    //     if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //       // use index to properly update table row after manipulation
    //       this.mouTable.items[idx].isFetching = true
    //       this.$axios.get(getUrl).then(response => {
    //         if(response.status == 200){
    //           this.initModalData()
    //           this.modalData.startDate.value = response.data.data.startDate
    //           this.modalData.endDate.value = response.data.data.endDate
    //           this.modalData.mouDate.value = response.data.data.mouDate
    //           this.modalData.description.value = response.data.data.description
    //           this.modalData.status.value = response.data.data.status
    //           // find and assign proper value from all available options
    //           for(let i = 0; i < this.modalData.mouType.options.length; i++){
    //             if(this.modalData.mouType.options[i].value == response.data.data["mouType"]){
    //               this.modalData.mouType.value = this.modalData.mouType.options[i]
    //               break
    //             }
    //           }
    //           for(let i = 0; i < this.modalData.officeCode.options.length; i++){
    //             if(this.modalData.officeCode.options[i].officeCode == response.data.data["officeCode"]){
    //               this.modalData.officeCode.value = this.modalData.officeCode.options[i]
    //               break
    //             }
    //           }
    //           // assign table
    //           for(let i = 0; i < response.data.data["mouDetails"].length; i++){
    //             this.addMouBussUnit()
    //             this.modalData.bussUnitTable.items[i].id = response.data.data["mouDetails"][i].id
    //             this.modalData.bussUnitTable.items[i].chargeAmount.value = response.data.data["mouDetails"][i].chargeAmount
    //             // find and assign proper value from all available options
    //             for(let j = 0; j < this.modalData.bussUnitAvailOptions.length; j++){
    //               if(this.modalData.bussUnitAvailOptions[j].value.bussUnit == response.data.data["mouDetails"][i].bussUnit && this.modalData.bussUnitAvailOptions[j].value.transType == response.data.data["mouDetails"][i].transType){
    //                 this.modalData.bussUnitTable.items[i].bussUnit.value = {
    //                   value: {
    //                     bussUnit: this.modalData.bussUnitAvailOptions[j].value.bussUnit,
    //                     transType: this.modalData.bussUnitAvailOptions[j].value.transType
    //                   },
    //                   text: this.modalData.bussUnitAvailOptions[j].text
    //                 }
    //                 this.modalData.bussUnitAvailOptions[j].$isDisabled = true
    //                 break
    //               }
    //             }
    //             for(let j = 0; j < this.modalData.bussUnitTable.items[i].status.options.length; j++){
    //               if(this.modalData.bussUnitTable.items[i].status.options[j].value == response.data.data["mouDetails"][i].status){
    //                 this.modalData.bussUnitTable.items[i].status.value = {
    //                   value: this.modalData.bussUnitTable.items[i].status.options[j].value,
    //                   text: this.modalData.bussUnitTable.items[i].status.options[j].text
    //                 }
    //               }
    //             }
    //             // for(let j = 0; j < this.modalData.officeCode.options.length; j++){
    //             //   if(this.modalData.officeCode.options[j].officeCode == response.data.data["officeCode"]){
    //             //     this.modalData.officeCode.value = this.modalData.officeCode.options[j]
    //             //     break
    //             //   }
    //             // }
    //           }
    //           this.modalData.isShowing = true
    //         }
    //         else{
    //           this.$helper.toastError(this, "Get Detail MoU Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //         }
    //       })
    //       .catch(error => {
    //         if(!this.$helper.isEmpty(error.response)){
    //           this.$helper.toastError(this, "Get Detail MoU Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //         }
    //         else{
    //           this.$helper.toastError(this, "Get Detail MoU Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //         }
    //       })
    //       .finally(() => {
    //         this.mouTable.items[idx].isFetching = false
    //       })
    //     }
    //     else{
    //       this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //     }

    //   }
    //   else{
    //     // clear modal and show if Add button is pressed
    //     this.modalData.mouId = ''
    //     this.initModalData()
    //     this.addMouBussUnit()
    //     this.addMouBussUnit()
    //     this.modalData.isShowing = true
    //   }
    // },
    // // validate vendor ID button functionality
    // validateVendorId() {
    //   let postUrl = '/notary/checkVendorId'
    //   let payload = new FormData()
    //   payload.append("vendorId", this.formData.vendorId.value)
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.formData.vendorId.isChecking = true
    //     this.$axios.post(postUrl, payload).then(response => {
    //       if(response.status == 200){
    //         this.formData.vendorId.isValid = true
    //         this.formData.vendorName.value = response.data.data.namaVendor
    //         this.formData.vendorBank.value = response.data.data.bank
    //         this.formData.vendorBankAccount.value = response.data.data.noRek
    //         this.formData.vendorStatus.value = response.data.data.statusRek
    //       }
    //       else{
    //         this.formData.vendorId.feedback = "Vendor ID tidak valid! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : "Unknown Error")
    //         this.formData.vendorId.isValid = false
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.formData.vendorId.feedback = "Vendor ID tidak valid! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found")
    //       }
    //       else{
    //         this.formData.vendorId.feedback = "Vendor ID tidak valid! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error")
    //       }
    //       this.formData.vendorId.isValid = false
    //     })
    //     .finally(() => {
    //       this.formData.vendorId.isChecking = false
    //     })
    //   }
    //   else {
    //     this.formData.vendorId.feedback = "Access Denied!"
    //     this.formData.vendorId.isValid = false
    //   }
    // },
    // // clear vendor inputs on vendor ID change
    // clearFormVendor() {
    //   this.formData.vendorId.isValid = null
    //   this.formData.vendorName.value = ''
    //   this.formData.vendorBank.value = ''
    //   this.formData.vendorBankAccount.value = ''
    //   this.formData.vendorStatus.value = ''
    // },
    // clear skb date form on selecting no skb
    clearSkbDate(){
      // this.formData.skbValidFrom.value = ''
      // this.formData.skbValidTo.value = ''
      // this.formData.skbValidFrom.isValid = null
      // this.formData.skbValidTo.isValid = null
    },
    // initModalData(){
    //   this.modalData.description.value = ''
    //   this.modalData.description.isValid = null
    //   this.modalData.startDate.value = ''
    //   this.modalData.startDate.isValid = null
    //   this.modalData.endDate.value = ''
    //   this.modalData.endDate.isValid = null
    //   this.modalData.mouDate.value = ''
    //   this.modalData.mouDate.isValid = null
    //   this.modalData.mouType.value = ''
    //   this.modalData.mouType.isValid = null
    //   this.modalData.officeCode.value = ''
    //   this.modalData.officeCode.isValid = null
    //   this.modalData.bussUnitTable.items = []
    //   for(let i = 0; i < this.modalData.bussUnitAvailOptions.length; i++){
    //     this.modalData.bussUnitAvailOptions[i].$isDisabled = false
    //   }
    // },
    // removeMouBussUnit(idx) {
    //   this.modalData.bussUnitTable.items.splice(idx, 1)
    //   this.onChangeBussUnit()
    // },
    // addMouBussUnit() {
    //   this.modalData.bussUnitTable.items.push({
    //     "id": -1,
    //     "bussUnit": this.$lodash.cloneDeep(this.modalData.bussUnitTemplate),
    //     "chargeAmount": this.$lodash.cloneDeep(this.modalData.chargeAmountTemplate),
    //     "status": this.$lodash.cloneDeep(this.modalData.bussUnitStatusTemplate)
    //   })
    // },
    // // populate select office dropdown dynamically
    // populateSelectOffice(query = "") {
    //   this.formData.office.isLoaded = false
    //   this.formData.office.totalPages = 0
    //   this.formData.office.totalRows = 0
    //   this.formData.office.currentPage = 1
    //   this.formData.office.lastQuery = query
    //   // URL builder
    //   let getUrl = "/notary/getAllOfficeByNotaryCode"
    //   // get content from current page
    //   getUrl += "?page=" + (this.formData.office.currentPage - 1)
    //   getUrl += "&size=" + this.formData.office.perPage
    //   if(query !== ""){
    //     getUrl += "&filterType=nameFull"
    //     getUrl += "&filterValue=" + query
    //   }
    //   // get office data based on notary id
    //   getUrl += "&id=" + this.$route.params.notarisId
    //   // get office data based on received user ID
    //   if(!this.$helper.isEmpty(this.formData.userId.value)){
    //     getUrl += "&userId=" + this.formData.userId.value
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         this.formData.office.options = []
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.formData.office.options.push(response.data.data.data[i])
    //         }
    //         this.formData.office.totalRows = response.data.data.totalElements
    //         this.formData.office.totalPages = response.data.data.totalPages
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.formData.office.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // // load more options for select office dropdown dynamically
    // appendSelectOffice() {
    //   this.formData.office.isLoaded = false
    //   // URL builder
    //   let getUrl = "/notary/getAllOfficeByNotaryCode"
    //   // get content from next page
    //   getUrl += "?page=" + (this.formData.office.currentPage)
    //   getUrl += "&size=" + this.formData.office.perPage
    //   if(this.formData.office.lastQuery !== ""){
    //     getUrl += "&filterType=nameFull"
    //     getUrl += "&filterValue=" + this.formData.office.lastQuery
    //   }
    //   // get office data based on notary id
    //   getUrl += "&id=" + this.$route.params.notarisId
    //   // get office data based on received user ID
    //   if(!this.$helper.isEmpty(this.formData.userId.value)){
    //     getUrl += "&userId=" + this.formData.userId.value
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.formData.office.options.push(response.data.data.data[i])
    //         }
    //         this.formData.office.currentPage++
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.formData.office.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // // populate modal office dropdown dynamically
    // populateModalOffice(query = "") {
    //   this.modalData.officeCode.isLoaded = false
    //   this.modalData.officeCode.totalPages = 0
    //   this.modalData.officeCode.totalRows = 0
    //   this.modalData.officeCode.currentPage = 1
    //   this.modalData.officeCode.lastQuery = query
    //   // URL builder
    //   let getUrl = "/notary/getAllOfficeByNotaryCode"
    //   // get content from current page
    //   getUrl += "?page=" + (this.modalData.officeCode.currentPage - 1)
    //   getUrl += "&size=" + this.modalData.officeCode.perPage
    //   if(query !== ""){
    //     getUrl += "&filterType=nameFull"
    //     getUrl += "&filterValue=" + query
    //   }
    //   // get office data based on notary id
    //   getUrl += "&id=" + this.$route.params.notarisId
    //   // get office data based on received user ID
    //   if(!this.$helper.isEmpty(this.formData.userId.value)){
    //     getUrl += "&userId=" + this.formData.userId.value
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         this.modalData.officeCode.options = []
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.modalData.officeCode.options.push(response.data.data.data[i])
    //         }
    //         this.modalData.officeCode.totalRows = response.data.data.totalElements
    //         this.modalData.officeCode.totalPages = response.data.data.totalPages
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.modalData.officeCode.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // // load more options for modal office dropdown dynamically
    // appendModalOffice() {
    //   this.modalData.officeCode.isLoaded = false
    //   // URL builder
    //   let getUrl = "/notary/getAllOfficeByNotaryCode"
    //   // get content from next page
    //   getUrl += "?page=" + (this.modalData.officeCode.currentPage)
    //   getUrl += "&size=" + this.modalData.officeCode.perPage
    //   if(this.modalData.officeCode.lastQuery !== ""){
    //     getUrl += "&filterType=nameFull"
    //     getUrl += "&filterValue=" + this.modalData.officeCode.lastQuery
    //   }
    //   // get office data based on notary id
    //   getUrl += "&id=" + this.$route.params.notarisId
    //   // get office data based on received user ID
    //   if(!this.$helper.isEmpty(this.formData.userId.value)){
    //     getUrl += "&userId=" + this.formData.userId.value
    //   }
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         for(let i = 0; i < response.data.data.data.length; i++){
    //           this.modalData.officeCode.options.push(response.data.data.data[i])
    //         }
    //         this.modalData.officeCode.currentPage++
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Office Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //       this.modalData.officeCode.isLoaded = true
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    // // get all, no pagination
    // populateModalBussUnit() {
    //   // URL builder
    //   let getUrl = "/bussUnit/getAll"
    //   // only send axios request if role is valid
    //   if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //     this.$axios.get(getUrl).then(response => {
    //       if(response.status == 200){
    //         this.modalData.bussUnitAvailOptions = []
    //         for(let i = 0; i < response.data.data.length; i++){
    //           this.modalData.bussUnitAvailOptions.push({
    //             "value": {
    //               "bussUnit": response.data.data[i].bussUnit,
    //               "transType": "F"
    //             },
    //             "text": response.data.data[i].bussUnit + " " + response.data.data[i].bussUnitDesc + " (Fiducia)"
    //           })
    //           this.modalData.bussUnitAvailOptions.push({
    //             "value": {
    //               "bussUnit": response.data.data[i].bussUnit,
    //               "transType": "R"
    //             },
    //             "text": response.data.data[i].bussUnit + " " + response.data.data[i].bussUnitDesc + " (Roya)"
    //           })
    //         }
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //       }
    //     })
    //     .catch(error => {
    //       if(!this.$helper.isEmpty(error.response)){
    //         this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //       }
    //       else{
    //         this.$helper.toastError(this, "Load Daftar Business Unit Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //       }
    //     })
    //     .finally(() => {
    //     })
    //   }
    //   else{
    //     this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //   }
    // },
    async getNotary(id){
      this.isLoading = true
      let getUrl = "/notary/getOneByCode/"

      let params = {
        id: id
      }
      
      await this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          for(const [key, data] of Object.entries(this.formData)){
            // check vendor id after assigning
            if(key == "vendorId"){
              data.value = response.data.data[data.payloadKey]
              this.formData.vendorId.isValid = true
            }
            // special case for multiselect inputs
            if(key == "type"){
              // find and assign proper value from all available options
              for(let j = 0; j < data.options.length; j++){
                if(data.options[j].value == response.data.data[data.payloadKey]){
                  data.value = data.options[j]
                  break
                }
              }
            }
            else if(key == "skb"){
              // find and assign proper value from all available options
              for(let j = 0; j < data.options.length; j++){
                if(data.options[j].value == response.data.data[data.payloadKey]){
                  data.value = data.options[j]
                  break
                }
              }
            }
            else if(key == "ppn"){
              // find and assign proper value from all available options
              for(let j = 0; j < data.options.length; j++){
                if(data.options[j].value == response.data.data[data.payloadKey]){
                  data.value = data.options[j]
                  break
                }
              }
            }
            else if(key == "status"){
              // find and assign proper value from all available options
              for(let j = 0; j < data.options.length; j++){
                if(data.options[j].value == response.data.data[data.payloadKey]){
                  data.value = data.options[j]
                  break
                }
              }
            }
            else if(key == "notaryCity") {
              if (!this.$helper.objectHasSameData({ code: null, name: null }, response.data.data[data.payloadKey])) {
                data.value = response.data.data[data.payloadKey]
              } else{
                data.value = null
              }
            }
            else if(key == "notaryZip") {
              let obj = {
                ...response.data.data[data.payloadKey],
                code: response.data.data[data.payloadKey].zipcode,
                name: response.data.data[data.payloadKey].zipcode,
              }
              data.value = obj
            }
            else if(key == "office"){
              // create temporary value object
              data.value = { "officeCode" : response.data.data["officeCode"], "nameFull" : response.data.data["officeName"] }
            }
            // assign all other input types
            else data.value = response.data.data[data.payloadKey]
          }
        }
        else{
          this.$helper.toastError(this, "Load Detail Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Detail Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Detail Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    editNotary(event) {
      event.preventDefault()
      // validate form entries before submit
      let isFormValid = true
      let obj = {}
      obj["id"] = this.$route.params.notarisId
      for(const [key, data] of Object.entries(this.formData)){
        // check Vendor ID field
        if(key == "vendorId"){
          if(data.isValid){
            obj[data.payloadKey] = data.value
          }
          else if(data.isRequired){
            data.feedback = "Please check Vendor ID validity."
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // check multiselect fields
        else if(key == "type"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        else if(key == "skb"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        else if(key == "ppn"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // check and mirror SKB Date fields if SKB is enabled
        else if(key == "skbValidFrom" || key == "skbValidTo"){
          if(!this.formData.skb.value.value){
            if(!this.$helper.isEmpty(this.formData.skbValidFrom.value) && !this.$helper.isEmpty(this.formData.skbValidTo.value)){
              data.isValid = null
              obj[data.payloadKey] = data.value
            }
            else if(this.formData.skbValidFrom.isRequired || this.formData.skbValidTo.isRequired){
              this.formData.skbValidFrom.isValid = false
              this.formData.skbValidTo.isValid = false
              isFormValid = false
            }
            else{
              data.isValid = null
            }
          }
          else{
            data.isValid = null
          }
        }
        else if(key == "status"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // check additional vendor data
        else if(key == "vendorBank" || key == "vendorBankAccount" || key == "vendorName" || key == "vendorStatus"){
          if(!this.$helper.isEmpty(data.value)){
            obj[data.payloadKey] = data.value
          }
          else{
            this.formData.vendorId.feedback = "Please check Vendor ID validity."
            this.formData.vendorId.isValid = false
            isFormValid = false
          }
        }
        else if(key == "notaryEmail"){
          if(!this.$helper.isEmpty(data.value)){
            if(!data.format.test(data.value)){
              data.feedback = 'Please enter a valid email format.'
              data.isValid = false
              isFormValid = false
            }
            else{
              data.isValid = null
              obj[data.payloadKey] = data.value
            }
          }
          else if(data.isRequired){
            data.feedback = 'This input is required.'
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        else if(key == "notaryCity") {
          if(this.$helper.isEmpty(data.value) && data.isRequired){
            data.feedback = 'This input is required.'
            data.isValid = false
            isFormValid = false
          } else{
            obj[data.payloadKey] = data.value.name
            data.isValid = null
          }
        }
        else if(key == "notaryZip") {
          if(this.$helper.isEmpty(data.value) && data.isRequired){
            data.feedback = 'This input is required.'
            data.isValid = false
            isFormValid = false
          } else{
            obj[data.payloadKey] = data.value.code
            data.isValid = null
          }
        }
        // skip checks on user and office inputs
        else if(key == "userId" || key == "office"){
          data.isValid = null
        }
        // check remaining fields
        else{
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/notary/edit/'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.$helper.toastSuccess(this, "Edit Notaris Berhasil!")
            }
            else{
              this.$helper.toastError(this, "Edit Notaris Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Edit Notaris Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Edit Notaris Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
          })
          .finally(() => {
            this.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    // saveMou(event) {
    //   event.preventDefault()
    //   // validate form entries before submit
    //   let isFormValid = true
    //   let obj = {}
    //   for(const [key, data] of Object.entries(this.modalData)){
    //     // skip unused properties
    //     if(key == "isShowing" || key == "isSubmitting" || key == "mouId" || key == "bussUnitAvailOptions" || key == "bussUnitTemplate" || key == "chargeAmountTemplate" || key == "bussUnitStatusTemplate"){
    //     }
    //     // check multiselect fields
    //     else if(key == "mouType"){
    //       if(!this.$helper.isEmpty(data.value)){
    //         data.isValid = null
    //         obj[data.payloadKey] = data.value.value
    //       }
    //       else if(data.isRequired){
    //         data.isValid = false
    //         isFormValid = false
    //       }
    //       else{
    //         data.isValid = null
    //       }
    //     }
    //     else if(key == "officeCode"){
    //       if(!this.$helper.isEmpty(data.value)){
    //         data.isValid = null
    //         obj[data.payloadKey] = data.value.officeCode
    //       }
    //       else if(data.isRequired){
    //         data.isValid = false
    //         isFormValid = false
    //       }
    //       else{
    //         data.isValid = null
    //       }
    //     }
    //     // check and mirror MoU Date fields
    //     else if(key == "startDate" || key == "endDate"){
    //       if(!this.$helper.isEmpty(this.modalData.startDate.value) && !this.$helper.isEmpty(this.modalData.endDate.value)){
    //         data.isValid = null
    //         obj[data.payloadKey] = data.value
    //       }
    //       else if(this.modalData.startDate.isRequired || this.modalData.endDate.isRequired){
    //         this.modalData.startDate.isValid = false
    //         this.modalData.endDate.isValid = false
    //         isFormValid = false
    //       }
    //       else{
    //         data.isValid = null
    //       }
    //     }
    //     // check all Business Unit Table rows
    //     else if(key == "bussUnitTable"){
    //       let mouDetails = []
    //       for(let i = 0; i < data.items.length;i++){
    //         let mouDetail = {}
    //         for(const [key, row] of Object.entries(data.items[i])){
    //           if(key == "id"){
    //             // if editing, add id information
    //             if(!this.$helper.isEmpty(this.modalData.mouId)){
    //               mouDetail["id"] = row
    //             }
    //           }
    //           else if(key == "bussUnit"){
    //             if(!this.$helper.isEmpty(row.value)){
    //               row.isValid = null
    //               mouDetail[row.payloadKey["bussUnit"]] = row.value.value.bussUnit
    //               mouDetail[row.payloadKey["transType"]] = row.value.value.transType
    //             }
    //             else if(row.isRequired){
    //               row.isValid = false
    //               isFormValid = false
    //             }
    //             else{
    //               row.isValid = null
    //             }
    //           }
    //           else if(key == "status"){
    //             if(!this.$helper.isEmpty(row.value)){
    //               row.isValid = null
    //               mouDetail[row.payloadKey] = row.value.value
    //             }
    //             else if(row.isRequired){
    //               row.isValid = false
    //               isFormValid = false
    //             }
    //             else{
    //               row.isValid = null
    //             }
    //           }
    //           else{
    //             if(!this.$helper.isEmpty(row.value)){
    //               row.isValid = null
    //               mouDetail[row.payloadKey] = row.value
    //             }
    //             else if(row.isRequired){
    //               row.isValid = false
    //               isFormValid = false
    //             }
    //             else{
    //               row.isValid = null
    //             }
    //           }
    //         }
    //         mouDetails.push(mouDetail)
    //       }
    //       obj["mouDetails"] = mouDetails
    //     }
    //     // check remaining fields
    //     else{
    //       if(!this.$helper.isEmpty(data.value)){
    //         data.isValid = null
    //         obj[data.payloadKey] = data.value
    //       }
    //       else if(data.isRequired){
    //         data.isValid = false
    //         isFormValid = false
    //       }
    //       else{
    //         data.isValid = null
    //       }
    //     }
    //   }
    //   // submit form data if every field is valid
    //   if(isFormValid){
    //     let postUrl = ''
    //     // if editing
    //     if(!this.$helper.isEmpty(this.modalData.mouId)){
    //       obj["mouId"] = this.modalData.mouId
    //       obj["userId"] = this.formData.userId.value
    //       postUrl = '/mou/edit'
    //     }
    //     // if adding
    //     else{
    //       obj["status"] = "NA"
    //       obj["userId"] = this.formData.userId.value
    //       postUrl = '/mou/add'
    //     }
    //     // only send axios request if role is valid
    //     if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
    //       this.modalData.isSubmitting = true
    //       this.$axios.post(postUrl, obj).then(response => {
    //         if(response.status == 200){
    //           this.$helper.toastSuccess(this, (this.$helper.isEmpty(this.modalData.mouId) ? "Add MoU Berhasil! Mohon melakukan Aktivasi MoU terlebih dahulu melalui tabel Data Mou." : "Edit MoU Berhasil!"))
    //           this.modalData.isShowing = false
    //           this.getMouTableItems()
    //         }
    //         else{
    //           this.$helper.toastError(this, (this.$helper.isEmpty(this.modalData.mouId) ? "Add MoU Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
    //         }
    //       })
    //       .catch(error => {
    //         if(!this.$helper.isEmpty(error.response)){
    //           this.$helper.toastError(this, (this.$helper.isEmpty(this.modalData.mouId) ? "Add MoU Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
    //         }
    //         else{
    //           this.$helper.toastError(this, (this.$helper.isEmpty(this.modalData.mouId) ? "Add MoU Gagal! " : "Edit MoU Gagal! ") + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
    //         }
    //       })
    //       .finally(() => {
    //         this.modalData.isSubmitting = false
    //       })
    //     }
    //     else{
    //       this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
    //     }
    //   }
    // },
    // isShowRemoveButton(rowId) {
    //   // if last table item, do not remove
    //   if(this.modalData.bussUnitTable.items.length <= 1) return false
    //   // if currently editing
    //   if(!this.$helper.isEmpty(this.modalData.mouId)) {
    //     // if row already exists
    //     if(rowId !== -1){
    //       return false
    //     }
    //   }
    //   return true
    // }
  },
  computed: {
  },
  async mounted() {
    // // get all available business unit selection
    // this.populateModalBussUnit()
    // get notary data based on notary id
    await this.populateCity()
    await this.populateZipcode()

    this.getNotary(this.$route.params.notarisId).then(() => {
      if(!this.$helper.isEmpty(sessionStorage.getItem("filterMouType" + String(this.$route.params.notarisId)))){
        this.filter.filterType = sessionStorage.getItem("filterMouType" + String(this.$route.params.notarisId))
        this.filter.value = sessionStorage.getItem("filterMouType" + String(this.$route.params.notarisId))
      }
      if(!this.$helper.isEmpty(sessionStorage.getItem("filterMouValue" + String(this.$route.params.notarisId)))){
        this.filter.filterValue = sessionStorage.getItem("filterMouValue" + String(this.$route.params.notarisId))
        this.filter.filterSearch = sessionStorage.getItem("filterMouValue" + String(this.$route.params.notarisId))
      }
      // // populate office data based on received user ID
      // this.populateSelectOffice()
      // this.populateModalOffice()
      // get table contents on page load
      this.getMouTableItems()

      // Add the city value to option if it is not listed and not null
      if (this.formData.notaryCity.value != null) {
        let cityFound = false
        for (const option of this.formData.notaryCity.options) {
          if (this.$helper.objectHasSameData(option, this.formData.notaryCity.value)) {
            cityFound = true
          }
        }
        if (!cityFound) this.formData.notaryCity.options.unshift(this.formData.notaryCity.value)
      }

      // Add the zip code value to option if it is not listed
      let zipcodeFound = false
      for (const option of this.formData.notaryZip.options) {
        if (this.$helper.objectHasSameData(option, this.formData.notaryZip.value)) {
          zipcodeFound = true
        }
      }
      if (!zipcodeFound) this.formData.notaryZip.options.unshift(this.formData.notaryZip.value)
    })
  },
  created(){
    if (this.$store.state.toast) {
      this.$helper.toastSuccess(this, this.$store.state.toastMsg)
      this.$store.commit('set', ['toast', false])
      this.$store.commit('set', ['toastMsg', ''])
    }
  }
}
</script>

<style>

</style>
